import { gql } from "@apollo/client";

export const GET_WEB_FEATURED_INFO = gql`
  {
    Info {
      webFeature {
        type_id
        name
        level
        price
        full_description
      }
    }
  }
`;

export const GET_CALCULATIONS = gql`
  query getCalculation(
    $land_area: Float!
    $floors_type: FloorsType!
    $basement_area: Float
  ) {
    HomePlans {
      buildingCalculator(
        land_area: $land_area
        floors_type: $floors_type
        basement_area: $basement_area
      ) {
        ground_floor_area
        first_floor_area
        roof_floor_area
        surface_area
        swimming_pool
        fence
        water_tank
        drainage_tank
        structural_concrete_cost
        finishing_costs
        turnkey_costs
      }
    }
  }
`;

export const GET_CONTACT_US_OPTIONS = gql`
  query {
    Info {
      contact_us_options {
        support {
          key
          user_id
          ar
          en
        }
        contact {
          key
          user_id
          ar
          en
        }
      }
    }
  }
`;
export const GET_GENERIC_BANNER = gql`
  query {
    Info {
      configurations {
        generic_banner
      }
    }
  }
`;
